// Stimulus controller wrapping intl-tel-input (real npm package, bundled
// locally — including its phone-formatting utils, no CDN involved at all).
// Splits the phone number into a country dial code + national number on
// submit, matching Account#phone_country_prefix / #phone_number.
import { Controller } from "@hotwired/stimulus"
import intlTelInput from "intl-tel-input/intlTelInputWithUtils"
import "intl-tel-input/build/css/intlTelInput.css"

export default class extends Controller {
  static targets = ["input", "prefix", "national"]

  connect() {
    this.iti = intlTelInput(this.inputTarget, {
      initialCountry: "ml",
      separateDialCode: true
    })
  }

  // Called on the form's submit event (data-action="submit->phone-input#split").
  split() {
    this.prefixTarget.value = "+" + this.iti.getSelectedCountryData().dialCode
    this.nationalTarget.value = this.inputTarget.value.replace(/\D/g, "")
  }

  disconnect() {
    this.iti?.destroy()
  }
}
